import { render } from "./cotizacionconsulta.vue?vue&type=template&id=494612fd"
import script from "./cotizacionconsulta.vue?vue&type=script&lang=js"
export * from "./cotizacionconsulta.vue?vue&type=script&lang=js"

import "./cotizacionconsulta.vue?vue&type=style&index=0&id=494612fd&lang=css"

import exportComponent from "D:\\proyectos\\WSP\\Git_Luhott\\ambiental-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__